/* ============================================================
   Tasty Flavours BYOB Bundle - frontend logic
   Geen dependencies. Werkt op Shopify Basic.
   Versie: 1.0
   ============================================================ */
(function () {
  'use strict';

  // Format money in EUR (matches "€8,50")
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  function init(root) {
    if (!root || root.dataset.tfInit === '1') return;
    root.dataset.tfInit = '1';

    var mode = root.dataset.mode;               // 'byob' | 'tiered'
    var targetPaid = parseInt(root.dataset.paidCount, 10) || 0;
    var targetFree = parseInt(root.dataset.freeCount, 10) || 0;
    var bundleId = root.dataset.bundleId;
    var bundleName = root.dataset.bundleName;
    var discountLabel = root.dataset.discountLabel;

    // State: map of "role:variantId" -> { qty, data }
    var state = {
      paid: {},  // variantId -> qty
      free: {},
      currentStep: 1
    };
    var productData = {}; // variantId -> {title, price, image, ...}

    // --- helpers ---
    function getCount(role) {
      return Object.values(state[role]).reduce(function (a, b) { return a + b; }, 0);
    }
    function getSubtotal() {
      var s = 0;
      Object.keys(state.paid).forEach(function (vid) {
        var p = productData[vid];
        if (p) s += p.price * state.paid[vid];
      });
      return s;
    }
    function getFreeValue() {
      var s = 0;
      Object.keys(state.free).forEach(function (vid) {
        var p = productData[vid];
        if (p) s += p.price * state.free[vid];
      });
      return s;
    }

    // --- DOM updates ---
    function updateCard(card) {
      var vid = card.dataset.variantId;
      var role = card.dataset.role;
      var qty = state[role][vid] || 0;
      var numEl = card.querySelector('[data-tf-qty-num]');
      if (numEl) numEl.textContent = qty;
      card.classList.toggle('is-selected', qty > 0);
    }

    function updateAllCardsDisabled() {
      var paidFull = getCount('paid') >= targetPaid;
      var freeFull = getCount('free') >= targetFree;
      root.querySelectorAll('[data-tf-grid="paid"] [data-tf-card]').forEach(function (c) {
        var vid = c.dataset.variantId;
        var has = (state.paid[vid] || 0) > 0;
        c.classList.toggle('is-disabled', paidFull && !has);
      });
      root.querySelectorAll('[data-tf-grid="free"] [data-tf-card]').forEach(function (c) {
        var vid = c.dataset.variantId;
        var has = (state.free[vid] || 0) > 0;
        c.classList.toggle('is-disabled', freeFull && !has);
      });
    }

    function updateSummary() {
      var list = root.querySelector('[data-tf-selected-list]');
      var empty = root.querySelector('[data-tf-empty]');
      if (!list) return;

      // Clear previous (keep empty placeholder)
      list.querySelectorAll('li:not([data-tf-empty])').forEach(function (li) { li.remove(); });

      var anySelected = false;

      function renderRow(vid, role, qty) {
        var p = productData[vid]; if (!p) return;
        anySelected = true;
        var li = document.createElement('li');
        var roleTag = role === 'free' ? ' <small style="color:#16a34a;font-weight:700;">GRATIS</small>' : '';
        li.innerHTML =
          (p.image ? '<img src="' + p.image + '" alt="">' : '') +
          '<div class="tf-sel-title"><b>' + escapeHtml(p.title) + '</b><small>' + qty + '× ' + (role === 'free' ? '€0,00' : formatMoney(p.price)) + roleTag + '</small></div>' +
          '<span class="tf-sel-price">' + (role === 'free' ? '€0,00' : formatMoney(p.price * qty)) + '</span>' +
          '<button type="button" class="tf-sel-remove" data-tf-remove data-role="' + role + '" data-vid="' + vid + '" aria-label="Verwijder">×</button>';
        list.appendChild(li);
      }
      Object.keys(state.paid).forEach(function (vid) { if (state.paid[vid] > 0) renderRow(vid, 'paid', state.paid[vid]); });
      Object.keys(state.free).forEach(function (vid) { if (state.free[vid] > 0) renderRow(vid, 'free', state.free[vid]); });

      if (empty) empty.style.display = anySelected ? 'none' : '';

      var paidVal = getSubtotal();   // betaalde items
      var freeVal = getFreeValue();  // waarde van gratis items
      var subtotal = paidVal + freeVal; // brutosubtotaal incl. gratis
      var total = paidVal;            // wat de klant écht betaalt

      var subEl = root.querySelector('[data-tf-subtotal]'); if (subEl) subEl.textContent = formatMoney(subtotal);
      var totalEl = root.querySelector('[data-tf-total]'); if (totalEl) totalEl.textContent = formatMoney(total);

      var dRow = root.querySelector('[data-tf-discount-row]');
      var dAmt = root.querySelector('[data-tf-discount-amount]');
      if (dRow && dAmt) {
        if (freeVal > 0) {
          dRow.hidden = false;
          dAmt.textContent = '−' + formatMoney(freeVal);
        } else {
          dRow.hidden = true;
        }
      }

      // Mobile bar
      var mTotal = root.querySelector('[data-tf-mobile-total]');
      var mCount = root.querySelector('[data-tf-mobile-count]');
      if (mTotal) mTotal.textContent = formatMoney(total);
      if (mCount) {
        if (state.currentStep === 1) mCount.textContent = getCount('paid') + ' / ' + targetPaid;
        else mCount.textContent = getCount('free') + ' / ' + targetFree;
      }
    }

    function updateProgress() {
      var pct;
      if (mode === 'tiered' && targetFree > 0) {
        if (state.currentStep === 1) pct = Math.min(100, (getCount('paid') / targetPaid) * 50);
        else pct = 50 + Math.min(50, (getCount('free') / targetFree) * 50);
      } else {
        pct = Math.min(100, (getCount('paid') / Math.max(1, targetPaid)) * 100);
      }
      var bar = root.querySelector('[data-tf-progress]');
      if (bar) bar.style.width = pct + '%';
      var progressEl = root.querySelector('.tf-byob__progress');
      if (progressEl) progressEl.setAttribute('aria-valuenow', Math.round(pct));
    }

    function updatePaidRemainingHint() {
      var rem = Math.max(0, targetPaid - getCount('paid'));
      var els = root.querySelectorAll('[data-tf-paid-remaining]');
      els.forEach(function (el) {
        el.textContent = rem === 0 ? '(volledig — ga verder)' : '(nog ' + rem + ' te kiezen)';
      });
      var fr = Math.max(0, targetFree - getCount('free'));
      var els2 = root.querySelectorAll('[data-tf-free-remaining]');
      els2.forEach(function (el) {
        el.textContent = fr === 0 ? '(volledig)' : '(nog ' + fr + ' te kiezen)';
      });
    }

    function updateCta() {
      var cta = root.querySelector('[data-tf-cta]');
      var ctaMob = root.querySelector('[data-tf-cta-mobile]');
      var helper = root.querySelector('[data-tf-cta-helper]');
      var paidOk = getCount('paid') >= targetPaid;
      var freeOk = targetFree === 0 || getCount('free') >= targetFree;

      var labelToStep2 = root.dataset.ctaToStep2 || 'Verder naar gratis maaltijden';
      var labelAddCart = root.dataset.ctaAddCart || 'Voeg toe aan winkelwagen';

      if (mode === 'tiered' && targetFree > 0 && state.currentStep === 1) {
        // CTA = go to step 2
        var enabled = paidOk;
        if (cta) { cta.disabled = !enabled; cta.textContent = labelToStep2; }
        if (ctaMob) { ctaMob.disabled = !enabled; ctaMob.textContent = labelToStep2; }
        if (helper) {
          helper.textContent = enabled ? 'Klaar — door naar je gratis maaltijden' : 'Kies eerst je betaalde maaltijden';
          helper.classList.toggle('is-ready', enabled);
        }
      } else {
        // CTA = add to cart
        var ready = paidOk && freeOk;
        if (cta) { cta.disabled = !ready; cta.textContent = labelAddCart; }
        if (ctaMob) { ctaMob.disabled = !ready; ctaMob.textContent = labelAddCart; }
        if (helper) {
          helper.textContent = ready ? 'Alles compleet — voeg toe aan winkelwagen' : 'Vul je bundel nog aan';
          helper.classList.toggle('is-ready', ready);
        }
      }
    }

    function renderAll() {
      root.querySelectorAll('[data-tf-card]').forEach(updateCard);
      updateAllCardsDisabled();
      updateSummary();
      updateProgress();
      updatePaidRemainingHint();
      updateCta();
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }

    // --- actions ---
    function addItem(card) {
      var vid = card.dataset.variantId;
      var role = card.dataset.role;
      var current = state[role][vid] || 0;
      var totalRole = getCount(role);
      var target = role === 'paid' ? targetPaid : targetFree;
      if (totalRole >= target) return; // full
      state[role][vid] = current + 1;
      renderAll();
    }
    function removeItem(role, vid) {
      var cur = state[role][vid] || 0;
      if (cur <= 1) delete state[role][vid];
      else state[role][vid] = cur - 1;
      renderAll();
    }
    function setStep(step) {
      state.currentStep = step;
      root.querySelectorAll('[data-tf-step-panel]').forEach(function (p) {
        var active = parseInt(p.dataset.tfStepPanel, 10) === step;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
      root.querySelectorAll('[data-tf-step-btn]').forEach(function (b) {
        var s = parseInt(b.dataset.tfStepBtn, 10);
        b.classList.toggle('is-active', s === step);
        b.classList.toggle('is-completed', s < step);
        if (s <= step || (s === 2 && getCount('paid') >= targetPaid)) b.removeAttribute('disabled');
      });
      // Scroll to top of section
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      renderAll();
    }

    // --- cart drawer integratie ---
    // Vindt de cart-icon trigger (theme's eigen openbutton).
    function findCartTrigger() {
      var triggers = [
        '[data-cart-drawer-toggle]',
        '#cart-icon-bubble',
        '.cart-icon-bubble',
        '[aria-controls="cart-drawer"]',
        '[aria-controls="CartDrawer"]',
        '.header__icon--cart',
        '.header__icon[href="/cart"]',
        '.js-drawer-open-cart',
        '#CartDrawer-Trigger',
        'a[href="/cart"]'
      ];
      for (var i = 0; i < triggers.length; i++) {
        var t = document.querySelector(triggers[i]);
        if (t && !t.closest('.tf-byob')) return t;
      }
      return null;
    }

    // Check of de drawer momenteel open is.
    function isDrawerOpen() {
      var d = document.querySelector('cart-drawer');
      if (d && (d.hasAttribute('open') || d.classList.contains('active') || d.classList.contains('open'))) return true;
      return !!document.querySelector('.cart-drawer.active, .drawer.active, .drawer--cart.active, [aria-hidden="false"].cart-drawer');
    }

    // Click trigger (of fallback methods) om de drawer te openen.
    function triggerOpen() {
      var trigger = findCartTrigger();
      if (trigger) { trigger.click(); return true; }

      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        try {
          if (typeof drawer.open === 'function') { drawer.open(); return true; }
          if (typeof drawer.show === 'function') { drawer.show(); return true; }
          drawer.classList.add('active','animate','open');
          drawer.classList.remove('is-empty');
          drawer.removeAttribute('hidden');
          drawer.setAttribute('open', '');
          return true;
        } catch (e) {}
      }

      ['cart:open','drawer:open','cart-drawer:open','shopify:cart:open'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      return false;
    }

    // Sluit drawer (zoekt close button of dispatcht close event).
    function triggerClose() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        try {
          if (typeof drawer.close === 'function') { drawer.close(); return true; }
          if (typeof drawer.hide === 'function') { drawer.hide(); return true; }
        } catch (e) {}
      }
      // Try close button inside drawer
      var closeBtn = document.querySelector(
        'cart-drawer [aria-label="Close" i], cart-drawer .drawer__close, ' +
        '.cart-drawer .drawer__close, .cart-drawer__close, ' +
        '[data-cart-drawer-close], .drawer__close-icon'
      );
      if (closeBtn) { closeBtn.click(); return true; }
      // Escape key fallback
      try {
        document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
      } catch (e) {}
      return false;
    }

    // Open de drawer (één keer, geen warmup nodig — we hebben de HTML al vervangen).
    function openCartDrawer() {
      // Probeer eerst direct .open() op cart-drawer element
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); return; } catch (e) {}
      }
      // Fallback: klik de cart trigger
      triggerOpen();
    }

    // ===== SECTION RENDERING API: vervang de cart-drawer HTML =====
    // Dit is de canonieke Dawn/Horizon manier. We krijgen de freshly rendered
    // section HTML terug van /cart/add.js en injecteren die in de bestaande DOM.
    // Hierdoor heeft de drawer DIRECT de juiste line items en is is-empty weg.
    function renderCartDrawerFromSections(sectionsObj) {
      if (!sectionsObj) return;

      // Helper: parse section HTML en pak een specifiek deel
      function getSectionContent(html, selector) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if (selector) {
            var el = doc.querySelector(selector);
            return el ? el.innerHTML : null;
          }
          return doc.body ? doc.body.innerHTML : null;
        } catch (e) {
          return null;
        }
      }

      // 1) Vervang #CartDrawer innerHTML (dat bevat de items + footer)
      var cartDrawerHtml = sectionsObj['cart-drawer'];
      if (cartDrawerHtml) {
        var newCartDrawerInner = getSectionContent(cartDrawerHtml, '#CartDrawer');
        var currentCartDrawer = document.getElementById('CartDrawer');
        if (newCartDrawerInner && currentCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawerInner;
        }

        // Verwijder is-empty class van cart-drawer wrapper
        var drawerWrapper = document.querySelector('cart-drawer');
        if (drawerWrapper) {
          drawerWrapper.classList.remove('is-empty');
        }
        // Verwijder is-empty class van cart-drawer-items
        var drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems) {
          drawerItems.classList.remove('is-empty');
        }
        // Enable checkout button als die disabled was
        var checkoutBtn = document.getElementById('CartDrawer-Checkout');
        if (checkoutBtn) {
          checkoutBtn.disabled = false;
          checkoutBtn.removeAttribute('disabled');
        }
      }

      // 2) Vervang cart-icon-bubble (de count badge in de header)
      var bubbleHtml = sectionsObj['cart-icon-bubble'];
      if (bubbleHtml) {
        var bubbleInner = getSectionContent(bubbleHtml, '.shopify-section') || bubbleHtml;
        var existingBubble = document.getElementById('cart-icon-bubble');
        if (existingBubble && bubbleInner) {
          existingBubble.innerHTML = bubbleInner;
        }
      }
    }

    // Publish events zodat eventuele andere theme listeners ook updaten
    function notifyThemeCartUpdated(cart) {
      var detail = { cart: cart, source: 'tf-byob' };
      ['cart:updated','cart:refresh','cart:build','cart-update'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: detail }));
      });
      if (typeof window.publish === 'function') {
        try { window.publish('cart-update', detail); } catch (e) {}
      }
    }

    // --- cart submission ---
    function submitToCart() {
      var cta = root.querySelector('[data-tf-cta]');
      var ctaMob = root.querySelector('[data-tf-cta-mobile]');
      var origLabel = cta ? cta.textContent : '';
      if (cta) cta.disabled = true;
      if (ctaMob) ctaMob.disabled = true;
      if (cta) cta.textContent = 'Bezig met toevoegen…';

      var items = [];
      function pushAll(role) {
        Object.keys(state[role]).forEach(function (vid) {
          var qty = state[role][vid];
          if (!qty) return;
          items.push({
            id: parseInt(vid, 10),
            quantity: qty,
            properties: {
              '_bundle_id': bundleId,
              '_bundle_name': bundleName,
              '_bundle_role': role  // 'paid' | 'free'
            }
          });
        });
      }
      pushAll('paid');
      pushAll('free');

      if (!items.length) return;

      // Stap 1: items toevoegen MET sections — Shopify rendert ze server-side
      // en geeft de HTML terug. Dat is de officiële Dawn/Horizon manier.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function (addResponse) {
          // Stap 2: reset BYOB state
          state.paid = {}; state.free = {}; state.currentStep = 1;
          renderAll();
          if (mode === 'tiered' && targetFree > 0) setStep(1);

          // Stap 3: vervang de cart-drawer HTML met de freshly rendered sections
          // Dit zorgt dat de drawer DIRECT de juiste items toont,
          // is-empty class weg is, en de AFREKENEN knop enabled.
          if (addResponse && addResponse.sections) {
            renderCartDrawerFromSections(addResponse.sections);
          }

          // Stap 4: haal de full cart op voor consistency (item count etc.)
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          // Stap 5: notify het thema (eventuele subscribe listeners)
          notifyThemeCartUpdated(cart);

          // Stap 6: open de drawer — DOM is al klaar dus dit is een normale open
          openCartDrawer();

          if (cta) { cta.disabled = false; cta.textContent = origLabel; }
          if (ctaMob) ctaMob.disabled = false;
        })
        .catch(function (err) {
          var msg = (err && err.description) || (err && err.message) || 'Er ging iets mis bij het toevoegen. Probeer het opnieuw.';
          alert(msg);
          console.error('[BYOB] cart/add error', err);
          if (cta) { cta.disabled = false; cta.textContent = origLabel || 'Voeg toe aan winkelwagen'; }
          if (ctaMob) ctaMob.disabled = false;
        });
    }

    // --- event delegation ---
    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-tf-card]');

      // Remove from summary list
      var rem = e.target.closest('[data-tf-remove]');
      if (rem) {
        removeItem(rem.dataset.role, rem.dataset.vid);
        return;
      }

      if (card) {
        if (e.target.closest('[data-tf-add]') || e.target.closest('[data-tf-qty-plus]')) {
          addItem(card);
          return;
        }
        if (e.target.closest('[data-tf-qty-minus]')) {
          var role = card.dataset.role;
          removeItem(role, card.dataset.variantId);
          return;
        }
      }

      // Step nav
      var stepBtn = e.target.closest('[data-tf-step-btn]');
      if (stepBtn && !stepBtn.disabled) {
        var s = parseInt(stepBtn.dataset.tfStepBtn, 10);
        if (s === 1 || (s === 2 && getCount('paid') >= targetPaid)) setStep(s);
        return;
      }

      // CTA
      var cta = e.target.closest('[data-tf-cta], [data-tf-cta-mobile]');
      if (cta && !cta.disabled) {
        if (mode === 'tiered' && targetFree > 0 && state.currentStep === 1) {
          setStep(2);
        } else {
          submitToCart();
        }
      }
    });

    // --- bootstrap: read product data from cards ---
    root.querySelectorAll('[data-tf-card]').forEach(function (card) {
      var vid = card.dataset.variantId;
      productData[vid] = {
        title: card.dataset.productTitle,
        price: parseInt(card.dataset.price, 10) || 0,
        image: card.dataset.image,
        handle: card.dataset.productHandle,
        variantTitle: card.dataset.variantTitle
      };
    });

    renderAll();
  }

  function bootstrap() {
    document.querySelectorAll('[data-tf-byob]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init for Shopify theme editor
  document.addEventListener('shopify:section:load', bootstrap);
})();
